/* eslint-disable import/prefer-default-export */

import {
  type ClassValue,
  clsx,
} from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * 根据locale生成正确的URL路径
 * 如果是默认语言(en)，不添加前缀；其他语言添加前缀
 */
export function getLocalizedPath(path: string, locale: string = 'en'): string {
  // 确保路径以 / 开头
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  // 如果是默认语言(英文)，不添加locale前缀
  if (locale === 'en') {
    return normalizedPath;
  }
  
  // 其他语言添加locale前缀
  return `/${locale}${normalizedPath}`;
}

/**
 * 保存用户语言偏好到cookie
 */
export function saveLocalePreference(locale: string): void {
  if (typeof document !== 'undefined') {
    // 设置cookie，30天过期
    document.cookie = `NEXT_LOCALE=${locale}; max-age=${30 * 24 * 60 * 60}; path=/; samesite=lax`;
  }
}

/**
 * 从cookie读取用户语言偏好
 */
export function getLocalePreference(): string | null {
  if (typeof document === 'undefined') return null;
  
  const matches = document.cookie.match(/NEXT_LOCALE=([^;]+)/);
  return matches ? decodeURIComponent(matches[1]) : null;
}

/**
 * 获取浏览器默认语言
 */
export function getBrowserLanguage(): string {
  if (typeof navigator === 'undefined') return 'en';
  
  const language = navigator.language || 'en';
  
  // 映射浏览器语言到支持的locale
  const languageMap: Record<string, string> = {
    'zh-CN': 'zh',
    'zh-TW': 'zh-tw',
    'zh-HK': 'zh-tw',
    'ja-JP': 'ja',
    'ko-KR': 'ko',
    'de-DE': 'de',
    'es-ES': 'es',
    'fr-FR': 'fr',
    'pl-PL': 'pl',
    'nl-NL': 'nl',
    'pt-BR': 'pt',
    'ru-RU': 'ru',
    'it-IT': 'it',
  };
  
  // 精确匹配
  if (languageMap[language]) {
    return languageMap[language];
  }
  
  // 模糊匹配（只匹配语言代码）
  const languageCode = language.split('-')[0];
  const supportedLanguages = ['zh', 'ja', 'ko', 'de', 'es', 'fr', 'pl', 'nl', 'pt', 'ru', 'it'];
  
  if (supportedLanguages.includes(languageCode)) {
    return languageCode;
  }
  
  // 默认返回英文
  return 'en';
}
